import { fabric } from 'fabric';

export class Point {
  id?: string;
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  public static convertFabricPathPoint(pathPoint: fabric.Point): Point {
    const pathPointInfos = pathPoint as any;
    const x = parseFloat(pathPointInfos[pathPointInfos.length - 2]);
    const y = parseFloat(pathPointInfos[pathPointInfos.length - 1]);
    return new Point(x, y);
  }

  public static convertFabricLine(line: fabric.Line): Point[] {
    return [new Point(line.x1, line.y1), new Point(line.x2, line.y2)];
  }
}
